import { Helmet } from 'react-helmet';
import './localBusinessSpotlight.css';

export default function LocalBusinessSpotlightSuccess() {
  return (
    <main className="spotlight-page spotlight-success-page">
      <Helmet>
        <title>Spotlight onboarding received | JG LocalOps</title>
      </Helmet>
      <section className="spotlight-success-card">
        <p className="spotlight-eyebrow">JG LOCAL BUSINESS SPOTLIGHT</p>
        <h1>PAYMENT RECEIVED.</h1>
        <p>
          Your advertisement is not live yet. We will review your information,
          prepare or verify the creative, and email you when the ad is live.
        </p>
        <p>
          Questions in the meantime? Contact{' '}
          <a href="mailto:support@joegalaxy.net">support@joegalaxy.net</a>.
        </p>
        <a
          className="spotlight-primary-link"
          href="/localops/region/camden/advertise"
        >
          RETURN TO SPOTLIGHT
        </a>
      </section>
    </main>
  );
}
